module.exports = "pegasus_template/assets/blocks/image-1-theme6.png";